<style>
.dropzone-area {
  border: 2px dashed rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 10px 0px;
  text-align: center;
  cursor: pointer;
}

.dropzone-title {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
}

.dropzone-subtitle {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
}

.dropzone-previews{
  height: 100%;
  width: 100%;
  padding: 10px 10px;
}

.dz-file-preview {
  display: none;
}

.dz-success-mark, .dz-error-mark, .dz-remove {
  display: none;
}
</style>

<template>
  <v-container
    align-center
    fluid
  >
    <v-layout
      align-center
      justify-space-around
      column
    >
        <v-card
          flat
          hover
          :raised="this.dndInProgress"
          :loading="this.files.length==2"
          :disabled="this.files.length==2"
          v-if="!muxed"
        >
          <vue-dropzone ref="myVueDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            :duplicateCheck=true
            :useCustomSlot=true
            :include-styling=false
            @vdropzone-file-added="fileAdded"
            @vdropzone-removed-file="fileRemoved"
            
            @vdropzone-max-files-exceeded="maxFilesExceeded"
            @vdropzone-max-files-reached="maxFilesReached"
            
            @vdropzone-duplicate-file="fileDuplicate"
            @vdropzone-error="fileError"

            @vdropzone-drag-start="dragStart"
            @vdropzone-drag-enter="dragStart"
            @vdropzone-drag-over="dragStart"

            @vdropzone-drop="dragEnd"
            @vdropzone-drag-leave="dragEnd"
            @vdropzone-drag-end="dragEnd"
            class="dropzone-area"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon size=60 v-if="this.files.length==0">add_photo_alternate</v-icon>
                </v-list-item-title>
                <v-list-item-title class="dropzone-title">
                  Add both the files here to merge them
                </v-list-item-title>
                <v-list-item-subtitle class="dropzone-subtitle">
                  Drag and drop them here or click to select files.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <div id="previewer" class="dropzone-previews">
              <v-list-item two-line v-if="this.files.length!=0 && !muxed">
                <v-list-item-content>
                  <v-list-item-title>
                      <file-item 
                        v-if="this.files.length>=1"
                        :file=this.getFile1()
                        :onRemove=removeFile
                      >
                      </file-item>
                  </v-list-item-title>
                  <v-list-item-title>
                      <file-item 
                        v-if="this.files.length>=2"
                        :file=this.getFile2()
                        :onRemove=removeFile
                      >
                      </file-item>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </vue-dropzone>
        </v-card>

        <v-card
          v-else
          :href=finalBlob
          dark
          hover
          :download=fileName()
          color=success
        >
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">Save File</v-list-item-title>
              <v-list-item-subtitle>Click to download the merged file</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar
              tile
              size="80"
              left
            >
              <v-icon size=60>save</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>

        <video-processor
          v-if="this.files.length==2"
          :file_one=files[0]
          :file_two=files[1]
          :onFinish=showDownload
        >
        </video-processor>


    </v-layout>
  </v-container>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import fileItem from './FileItem.vue'
// Lazy Load the videoProcessor 
const videoProcessor = () => import('./VideoProcessor.vue')

export default {
  data: () => ({
    dropzoneOptions: {
          url: "https://www/reddit.watch/upload",
          maxFiles: 2,
          acceptedFiles: ".mp4",
          autoProcessQueue: false,
          autoQueue: false,
          addRemoveLinks: false,
          createImageThumbnails: false,
          clickable: ".dropzone-area",
          //Customize the dropzone default messages
          dictDefaultMessage: "",
      },
    dndInProgress: false,
    processing: false,
    no_of_files: 0,
    files: [],
    getFile1: function(){if(this.files.length>=1){return this.files[0]}else{return }},
    getFile2: function(){if(this.files.length>=2){return this.files[1]}else{return }},
    muxed: false,
    finalBlob: ""
  }),
  components: {
    "vue-dropzone": vue2Dropzone,
    "file-item": fileItem,
    "video-processor": videoProcessor
  },
  methods: {
    maxFilesExceeded: function(file) {
      this.$refs.myVueDropzone.removeFile(file);
      this.files = this.$refs.myVueDropzone.getAddedFiles()
    },
    maxFilesReached: function(file) {
      file;
    },
    fileAdded: function(file) {
      file;
      this.files = this.$refs.myVueDropzone.getAddedFiles()
    },
    fileRemoved: function(file, error, xhr) {
      file; error; xhr;
      this.files = this.$refs.myVueDropzone.getAddedFiles()
      this.processing = false
    },
    removeFile: function(file) {
      this.$refs.myVueDropzone.removeFile(file);
    },
    fileError: function(file, message, xhr) {
      file; message; xhr;
      //TODO Show alert
      this.files = this.$refs.myVueDropzone.getAddedFiles()
    },
    fileDuplicate: function(file) {
      file;
      this.$refs.myVueDropzone.removeFile(file);
      this.files = this.$refs.myVueDropzone.getAddedFiles()
    },
    dragStart: function(event) {
      event;
      this.dndInProgress = true

    },
    dragEnd: function(event) {
      event;
      this.dndInProgress = false
    },
    showDownload: function(url) {
      this.finalBlob = url
      this.muxed = true
    },
    fileName: function () {
      let randNumber = Math.floor(Math.random() * (9999 - 1000)) + 1000
      return "Video "+randNumber+" [www.reddit.watch].mp4"
    }
  }
}
</script>